import { Row, Col, Card, Typography, Avatar } from "antd";
import { getCardStyle } from "../../../utils/getCardStyle";
const { Text } = Typography;

const PaletCardConsultaStock = ({ darkMode, item, index }) => (
  <Col span={24} key={item.idartp + index}>
    <Card
      hoverable
      styles={{ body: { padding: 16 } }}
      style={{
        ...getCardStyle(darkMode),
        height: "100%",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",
          gap: "16px",
        }}
      >
        <div style={{ flex: 1 }}>
          <Text
            strong
            style={{
              fontSize: "20px",
              color: darkMode ? "#fff" : "#000",
              display: "block",
              marginBottom: "4px",
            }}
          >
            {item.codigo}
            {item.ctdpar > 1 && item.nropar
              ? `-${String(item.nropar).padStart(2, "0")}`
              : ""}
          </Text>

          <Text
            strong
            style={{
              fontSize: "16px",
              color: darkMode ? "#ccc" : "#555",
              display: "block",
            }}
          >
            {item.nombre}
          </Text>

          <Text
            strong
            style={{
              fontSize: "16px",
              color: darkMode ? "#ccc" : "#555",
              display: "block",
            }}
          >
            {item?.nomfis}
          </Text>

          <Text
            strong
            type="secondary"
            style={{
              fontSize: "16px",
              color: darkMode ? "#999" : "#777",
              display: "block",
            }}
          >
            {item.modelo}
          </Text>
          <Text
            type="secondary"
            style={{
              fontSize: "16px",
              color: darkMode ? "#999" : "#777",
              display: "block",
            }}
          >
            {item.nompar}
          </Text>
        </div>

        <div
          style={{
            textAlign: "right",
            flexShrink: 0,
            minWidth: "120px",
          }}
        >
          <Text
            strong
            style={{
              fontSize: "20px",
              display: "block",
              marginBottom: "8px",
            }}
          >
            {item.etique}
          </Text>
          <Avatar
            src="/assets/palet.png"
            size={60}
            style={{ backgroundColor: "#d5c279" }}
          />
        </div>
      </div>

      {/* Estadísticas (igual que artículo) */}
      <Row
        style={{
          marginTop: "12px",
          paddingTop: "12px",
          borderTop: `1px solid ${darkMode ? "#444" : "#eee"}`,
        }}
        gutter={[8, 8]}
      >
        {[
          { label: "cmp", value: item.ctdcmp },
          { label: "ret", value: item.ctdret },
          { label: "pik", value: item.ctdpik },
          { label: "dis", value: item.ctddis },
          { label: "plt", value: item.ctdplt },
          { label: "fis", value: item.ctdfis },
        ].map((stat) => (
          <Col key={stat.label} xs={8} sm={4} md={4}>
            <Text
              type="secondary"
              style={{
                fontSize: "17px",
                color: darkMode ? "#ccc" : "#555",
                display: "block",
                textAlign: "center",
              }}
            >
              {stat.label}: {Math.round(stat.value)}
            </Text>
          </Col>
        ))}
      </Row>
    </Card>
  </Col>
);

export default PaletCardConsultaStock;
